import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import FormChecker from 'src/app/core/utils/form-checker';
import { CustomInput } from '../CustomInput';

@Component({
  selector: 'app-input-cnpj',
  templateUrl: './input-cnpj.component.html',
  styleUrls: ['./input-cnpj.component.scss'],
})
export class InputCnpjComponent extends CustomInput {
  @Input() label = 'CNPJ';
  @Input() icon: string | undefined;

  override control = new UntypedFormControl(null, FormChecker.cnpj);
  override errorList = ['invalidCnpj'];
}
